import { getAxiosInstance } from "../Config";

//* GET PATIENT ENROLLMENT OVER TIME REPORT BY MONTH
export const patientEnrollmentReport = async () => {
    const axiosInstance = await getAxiosInstance();
  
    return axiosInstance
      .get("/reporting/getEnrollmentStatSPerMonth")
      .then((response) => {
        if (response.status !== 200) {
          throw new Error(`Error: ${response.data}`);
        }
        return response.data;
      })
      .catch((error) => {
        console.error(error.message);
      });
  };


  //* GET PATIENT ENROLLMENT OVER TIME REPORT BY MONTH
export const AnalyticsBySite = async (Phase) => {
  const axiosInstance = await getAxiosInstance();

  return axiosInstance
    .get("/reporting/getSiteAnalytics",
    {params: {phase: Phase}}
    )
    .then((response) => {
      if (response.status !== 200) {
        throw new Error(`Error: ${response.data}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error(error.message);
    });
};


//* GET PATIENT data for CSV
export const getCSV_Data = async (Phase) => {
  const axiosInstance = await getAxiosInstance();

  return axiosInstance
    .get("/reporting/generateCSV",
    {params: {phase: Phase}}
    )
    .then((response) => {
      if (response.status !== 200) {
        throw new Error(`Error: ${response.data}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error(error.message);
    });
};
  
  